import { LookupWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Lookup')
export class LookupNodeSchemaProvider extends SchemaProvider<LookupWorkflowNode> {}
